import React, {
  useState,
  useMemo,
  useEffect,
  useLayoutEffect,
  useRef,
} from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import styled from 'styled-components';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  workNumModifyStateRecoil,
  fakeWorkNumModifyStateRecoil,
  monthUnitPriceModifyStateRecoil,
  privacyAgreementStateRecoil,
} from '../atom/ModalAtom';
import Header1 from '../component/Header1';
import WorkNumModiFy from '../modal/input/WorkNumModiFy';
import FakeWorkNumModiFy from '../modal/input/FakeWorkNumModiFy';
import { userIdState } from '../atom/TokenAtom';
import {
  WorkNumDto,
  FakeWorkNumsDto,
  FakeWorkNumDto,
  WorkNumListsDto,
} from '../model/room.dto';
import { authAPI, roomAPI } from '../api/axiosIndex';
import { MyInforDto } from '../model/user.dto';
import MonthUnitPriceModiFy from '../modal/input/MonthUnitPriceModiFy';
import PrivacyAgreement from '../modal/input/PrivacyAgreement';
import { Icon } from '../component/Icon';

const WorkNumManage = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);

  const [workNumModifyState, setWorkNumModifyState] = useRecoilState(
    workNumModifyStateRecoil,
  );
  const [fakeWorkNumModifyState, setFakeWorkNumModifyState] = useRecoilState(
    fakeWorkNumModifyStateRecoil,
  );
  const [monthUnitPriceModiFyState, setMonthUnitPriceModiFyState] =
    useRecoilState(monthUnitPriceModifyStateRecoil);
  const [privacyAgreementState, setPrivacyAgreementState] = useRecoilState(
    privacyAgreementStateRecoil,
  );

  const optionYears: number[] = [2024, 2025, 2026, 2027, 2028, 2029, 2030];
  const optionMonth: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const [today, setToday] = useState(new Date());
  const [todayYear, setTodayYear] = useState(today.getFullYear());
  const [todayMonth, setTodayMonth] = useState(today.getMonth() + 1);
  const [todayDay, setTodayDay] = useState(today.getDate());
  const [selectYear, setSelectYear] = useState<number | null>(
    today.getFullYear(),
  );
  const [selectMonth, setSelectMonth] = useState<number | null>(
    today.getMonth() + 1,
  );
  const [selectFakeWorkNum, setSelectFakeWorkNum] =
    useState<FakeWorkNumDto | null>(null);
  const [workNums, setWorkNums] = useState<WorkNumDto | null>(null);
  const [fakeWorkNums, setFakeWorkNums] = useState<FakeWorkNumsDto | null>(
    null,
  );
  const [todayFakeWorkNum, setTodayFakeWorkNum] =
    useState<FakeWorkNumDto | null>(null);
  const [workNumLists, setWorkNumLists] = useState<WorkNumListsDto | null>(
    null,
  );
  const [workNumChecked, setWorkNumChecked] = useState<boolean>(true);
  const [monthlySale, setMonthlySale] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [myInfors, setMyInfors] = useState<MyInforDto | null>(null);

  const fetchMyInfors = async () => {
    try {
      const response = await authAPI.getMyInfor();
      setMyInfors(response.data);
    } catch (err: any) {
      console.log(err);
    }
  };

  const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectYear(parseInt(e.target.value));
    setSelectMonth(null);
    setCurrentPage(1);
  };

  const handleMonthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectMonth(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const getWorkNums = async () => {
    try {
      const response = await roomAPI.getWorkNums(Number(userId));
      setWorkNums(response.data[0]);
    } catch (err: any) {
      setError('탕수 조회에 실패하였습니다.');
    }
  };

  const getFakeWorkNums = async () => {
    try {
      const response = await roomAPI.getFakeWorkNums();
      setFakeWorkNums(response.data);
      setTodayFakeWorkNum(
        response.data.find(
          (workNum) => workNum.month === today.getMonth() + 1,
        ) || null,
      );
      setSelectFakeWorkNum(
        response.data.find(
          (workNum) =>
            workNum.year === selectYear && workNum.month === selectMonth,
        ) || null,
      );
    } catch (err: any) {
      setError('가탕 조회에 실패하였습니다.');
    }
  };

  const getWorkNumLists = async () => {
    let accumulatedCycle = 0;
    let trueAccumulatedCycle = 0;
    if (selectFakeWorkNum?.addition === undefined) {
      getFakeWorkNums();
    } else if (selectFakeWorkNum?.addition !== undefined) {
      accumulatedCycle = selectFakeWorkNum.addition;
    }

    try {
      const response = await roomAPI.getDateWorkNums(
        Number(selectYear),
        Number(selectMonth),
      );
      const accumulatedList = response.data.map((item) => {
        trueAccumulatedCycle += item.cycle;
        accumulatedCycle += item.cycle;
        return {
          ...item,
          trueAccumulatedCycle,
          accumulatedCycle,
        };
      });
      const sortedList = accumulatedList.sort((a, b) => {
        if (a.year !== b.year) return b.year - a.year;
        if (a.month !== b.month) return b.month - a.month;
        return b.day - a.day;
      });
      if (workNumChecked) {
        const filteredList = sortedList.filter((item) => item.cycle !== 0);
        setWorkNumLists(filteredList);
      } else {
        setWorkNumLists(sortedList);
      }
    } catch (err: any) {
      console.log(err);
    }
  };

  const getMonthUnitPrice = async () => {
    try {
      const response = await roomAPI.getMonthUnitPrice(
        Number(todayYear),
        Number(todayMonth),
      );
      setMonthlySale(response.data.monthlySale);
    } catch (err: any) {
      setError('당월 단가 조회에 실패하였습니다.');
    }
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handleWorkNumCheckBoxChange = () => {
    setWorkNumChecked(!workNumChecked);
    setCurrentPage(1);
  };

  const handleListUpdate = async () => {
    await getWorkNums();
    await getFakeWorkNums();
    await getWorkNumLists();
    await getMonthUnitPrice();
  };

  const formattedDate = `${todayYear}.${todayMonth}.${todayDay}`;
  const totalWorkNums =
    (todayFakeWorkNum?.addition || 0) + (workNums?.monthCycle || 0);

  useEffect(() => {
    getWorkNums();
    getFakeWorkNums();
    getWorkNumLists();
  }, [selectYear, selectMonth]);

  useEffect(() => {
    if (selectFakeWorkNum) {
      getWorkNumLists();
    }
  }, [selectFakeWorkNum, workNumChecked]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = workNumLists?.slice(indexOfFirstItem, indexOfLastItem);
  const totalItems = workNumLists?.length || 0;
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  useEffect(() => {
    fetchMyInfors();
    getMonthUnitPrice();
  }, []);

  useEffect(() => {
    if (myInfors) {
      if (!myInfors.privacyPolicyAgreed) {
        setPrivacyAgreementState(true);
      }
    }
  }, [myInfors]);

  return (
    <>
      <Header1 title="일보 관리" />
      <LS.MainCntLayout>
        <TopTitieWrap>
          <DateBox>
            <span className="img-box">
              <Icon name="DateIcon" size="100%" color="#6B7684" />
            </span>
            <span className="date">{formattedDate}</span>
          </DateBox>
          <NickNameBox>
            <span className="nickname">{myInfors?.nickname}</span>
            <span className="text">님</span>
          </NickNameBox>
        </TopTitieWrap>
        <WorkWrap>
          <WorkBox>
            <li className="today">
              <h1>당월 매출</h1>
              <div className="text-wrap">
                <ul className="text-box-1">
                  <li>총</li>
                </ul>
                <ul className="text-box-2">
                  <li>
                    <span className="num">{monthlySale.toLocaleString()}</span>
                    원
                  </li>
                </ul>
              </div>
            </li>
            <li className="today">
              <h1>당일</h1>
              <div className="text-wrap">
                <ul className="text-box-1">
                  <li>총</li>
                </ul>
                <ul className="text-box-2">
                  <li>
                    <span className="num">{workNums?.todayCycle}</span>건
                  </li>
                </ul>
              </div>
            </li>
          </WorkBox>
          <WorkBox>
            <li className="month">
              <h1>당월</h1>
              <div className="text-wrap">
                <ul className="text-box-1">
                  <li>실회전</li>
                  <li>가회전</li>
                  <li>누적</li>
                </ul>
                <ul className="text-box-2">
                  <li>
                    <span className="num">{workNums?.monthCycle}</span>건
                  </li>
                  <li>
                    <span className="num">{todayFakeWorkNum?.addition}</span>건
                  </li>
                  <li>
                    <span className="num">{totalWorkNums}</span>건
                  </li>
                </ul>
              </div>
            </li>
          </WorkBox>
        </WorkWrap>
        <DateOptionBox>
          <div className="left-box">
            <div className="select-box">
              <select
                value={selectYear !== null ? selectYear : ''}
                onChange={handleYearChange}
                className="year"
              >
                {optionYears
                  .filter((year) => year <= todayYear)
                  .map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
              </select>
              <span className="img-box">
                <Icon name="ArrowBottomIcon" size="100%" color="#D8D7DC" />
              </span>
            </div>
            <div className="select-box">
              <select
                value={selectMonth !== null ? selectMonth : ''}
                onChange={handleMonthChange}
                className="month"
              >
                {optionMonth.map((month) => (
                  <option key={month} value={month}>
                    {month}
                  </option>
                ))}
              </select>
              <span className="img-box">
                <Icon name="ArrowBottomIcon" size="100%" color="#D8D7DC" />
              </span>
            </div>
          </div>
          <div className="right-box">
            <div className="num-ctrl-box">
              <h3>근무날</h3>
              <CS.CtrlBox>
                <input
                  type="checkbox"
                  id="work_check_box"
                  checked={workNumChecked}
                  onChange={handleWorkNumCheckBoxChange}
                />
                <label htmlFor="work_check_box"></label>
              </CS.CtrlBox>
            </div>
          </div>
        </DateOptionBox>
        <TableBox>
          <CS.TableType1>
            <table>
              <thead>
                <tr>
                  <th>날짜</th>
                  <th>오늘</th>
                  <th>누적</th>
                  <th>실회전</th>
                  <th>가회전</th>
                </tr>
              </thead>
              <tbody>
                {currentItems?.map((list, index) => {
                  return (
                    <tr key={list.id}>
                      <td>
                        {list.month}/{list.day}
                      </td>
                      <td>{list.cycle}</td>
                      <td>{list.accumulatedCycle}</td>
                      <td>{list.trueAccumulatedCycle}</td>
                      {index === 0 && (
                        <td rowSpan={currentItems.length}>
                          {selectFakeWorkNum?.addition}
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </CS.TableType1>
        </TableBox>
        <BtnBox>
          <CS.Btn3Type3
            type="button"
            onClick={() => setMonthUnitPriceModiFyState(true)}
          >
            단가 수정
          </CS.Btn3Type3>
          <CS.Btn3Type1
            type="button"
            onClick={() => setWorkNumModifyState(true)}
          >
            실 수정
          </CS.Btn3Type1>
          <CS.Btn3Type2
            type="button"
            onClick={() => setFakeWorkNumModifyState(true)}
          >
            가 수정
          </CS.Btn3Type2>
        </BtnBox>
        <CS.Pagenation>
          <button
            className="img-box"
            type="button"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <Icon name="ArrowPrevIcon" size="100%" color="#949494" />
          </button>
          <ul>
            {pageNumbers.map((number) => (
              <li
                key={number}
                className={currentPage === number ? 'active' : ''}
                onClick={() => handlePageChange(number)}
              >
                {number}
              </li>
            ))}
          </ul>
          <button
            className="img-box"
            type="button"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={
              currentPage === pageNumbers.length || pageNumbers.length === 0
            }
          >
            <Icon name="ArrowNextIcon" size="100%" color="#949494" />
          </button>
        </CS.Pagenation>
      </LS.MainCntLayout>
      {workNumModifyState && <WorkNumModiFy onListUpdate={handleListUpdate} />}
      {fakeWorkNumModifyState && (
        <FakeWorkNumModiFy onListUpdate={handleListUpdate} />
      )}
      {monthUnitPriceModiFyState && (
        <MonthUnitPriceModiFy onListUpdate={handleListUpdate} />
      )}
      {privacyAgreementState && <PrivacyAgreement />}
    </>
  );
};

export default WorkNumManage;

const TopTitieWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DateBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  padding: 0 8px;

  .img-box {
    width: 14px;
  }

  .date {
    font-size: 12px;
    font-weight: 700;
  }
`;

export const NickNameBox = styled.div`
  box-sizing: border-box;
  padding-right: 8px;
  display: flex;
  align-items: flex-end;
  gap: 2px;
  .nickname {
    font-size: 15px;
    font-weight: 700;
  }
  .text {
    font-size: 15px;
    font-weight: 500;
    color: #555;
  }
`;

export const WorkWrap = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 12px;
`;

export const WorkBox = styled.ul`
  &:first-child {
    display: flex;
    flex-direction: column;
    gap: 8px;
    > li {
      height: 100%;
    }
  }
  > li {
    width: 100%;
    height: 150px;
    box-sizing: border-box;
    padding: 12px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    > h1 {
      font-size: 13px;
      color: #fff;
      font-weight: 700;
    }

    .text-wrap {
      display: flex;
      justify-content: flex-end;
      gap: 6px;

      .text-box-1 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        > li {
          font-size: 15px;
          font-weight: 500;
          color: #fff;
        }
      }

      .text-box-2 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        > li {
          font-size: 15px;
          font-weight: 500;
          color: #fff;
          text-align: right;
          > .num {
            display: inline-block;
            font-weight: 500;
          }
        }
      }
    }
  }

  > li.today {
    background-color: #4e5565;

    .num {
      color: #00ffba;
    }
  }

  > li.month {
    background-color: #2869e2;

    .num {
      color: #ffb400;
    }
  }
`;
export const DateOptionBox = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: 24px;

  .left-box {
    display: flex;
    gap: 8px;

    .select-box {
      position: relative;

      select {
        height: 48px;
        background-color: #fff;
        border-radius: 8px;
        color: #000;
        font-size: 14px;
        border: 1px solid #d6dbe1;
        box-sizing: border-box;
        padding: 0 12px;
        &.year {
          width: 80px;
        }
        &.month {
          width: 60px;
        }
      }

      .img-box {
        width: 22px;
        position: absolute;
        top: 50%;
        right: 4px;
        transform: translateY(-50%);
        pointer-events: none;
      }
    }
  }

  .right-box {
    .num-ctrl-box {
      display: flex;
      align-items: flex-end;
      gap: 6px;

      > h3 {
        font-size: 12px;
        color: #666;
      }
    }
  }
`;
export const TableBox = styled.div`
  margin-top: 10px;
`;
export const BtnBox = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
